module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addPlatform":"Add Platform","version":"Version","downloadNewVersion":"Download New","lastActivity":"Last activity"},"es":{"addPlatform":"Agregar Plataforma","version":"Versión","downloadNewVersion":"Descargar Nueva","lastActivity":"Últ. actividad"}}')
  delete Component.options._Ctor
}
